import React from "react";
import PropTypes from 'prop-types'

const EventVideoPlayer = ({ media }) => {
  if (!media?.mediaUrl) return null;

  return (
    <div style={styles.wrapper}>
      <video
        controls
        preload="metadata"
        crossOrigin="anonymous"
        playsInline
        style={styles.video}
      >
        <source src={media.mediaUrl} type="video/mp4" />
      </video>
    </div>
  );
};

const styles = {
  wrapper: {
    // maxWidth: "800px",
    // margin: "20px auto",
    // padding: "10px",
    // borderRadius: "10px",
    // background: "#000",
  },
  video: {
    width: "100%",
    height: "100%",
  },
  meta: {
    color: "#fff",
    fontSize: "14px",
    marginTop: "8px",
  },
};
EventVideoPlayer.propTypes = {
  media: PropTypes.any
}

export default EventVideoPlayer;
